import { Box } from '@mui/material';
import React, { useState } from 'react';

export default function MapControls(props) {
  const { sx = {}, top, children, ...rest } = props;
  const [openControl, setOpenControl] = useState(null);
  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        zIndex: 1000,
        pointerEvents: 'none',
        ...sx,
      }}
      {...rest}
    >
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {top}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            flex: 1,
          }}
        >
          {React.Children.map(
            children,
            (child, i) =>
              child &&
              React.cloneElement(child, {
                canOpen: !openControl || openControl === i + 1,
                triggerControlChange: () => {
                  const controlId = i + 1;
                  setOpenControl(controlId === openControl ? null : controlId);
                },
              }),
          )}
        </Box>
      </Box>
    </Box>
  );
}
